<template>
<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.1667 18.3333V15H13.1667V18.3333M7.33336 4.99999H7.3417M14 4.99999H14.0084M10.6667 4.99999H10.675M10.6667 8.33332H10.675M10.6667 11.6667H10.675M14 8.33332H14.0084M14 11.6667H14.0084M7.33336 8.33332H7.3417M7.33336 11.6667H7.3417M5.6667 1.66666H15.6667C16.5872 1.66666 17.3334 2.41285 17.3334 3.33332V16.6667C17.3334 17.5871 16.5872 18.3333 15.6667 18.3333H5.6667C4.74622 18.3333 4.00003 17.5871 4.00003 16.6667V3.33332C4.00003 2.41285 4.74622 1.66666 5.6667 1.66666Z" stroke="#30485E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
  name: "BuildingIcon"
}
</script>

